import { lazy } from "react";

// project-imports
import MainLayout from "layout/MainLayout";
import CommonLayout from "layout/CommonLayout";
import Loadable from "components/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";
// import { title } from 'process';

const MaintenanceError = Loadable(
  lazy(() => import("pages/maintenance/error/404"))
);
const MaintenanceError500 = Loadable(
  lazy(() => import("pages/maintenance/error/500"))
);
const MaintenanceUnderConstruction = Loadable(
  lazy(() => import("pages/maintenance/under-construction/under-construction"))
);
const MaintenanceComingSoon = Loadable(
  lazy(() => import("pages/maintenance/coming-soon/coming-soon"))
);

// render - sample page
const SamplePage = Loadable(
  lazy(() => import("pages/extra-pages/sample-page"))
);
const Dashboard = Loadable(
  lazy(() => import("pages/App_Aplicacion/_Home/default"))
);
// ===========|| MAIN ROUTES Sistema de Manifiestos ||============================== //

const PageDocumentacion = Loadable(
  lazy(() => import("pages/App_Aplicacion/Documenacion"))
);
const PageInformacionContacto = Loadable(
  lazy(() => import("pages/App_Aplicacion/Soporte"))
);

const PageChofer = Loadable(lazy(() => import("pages/App_Catalogo/Chofer")));
const AvisoGeneral = Loadable(lazy(() => import("pages/App_Catalogo/Avisos/General")));
const AvisoAduana = Loadable(lazy(() => import("pages/App_Catalogo/Avisos/Aduana")));
const PageTractor = Loadable(lazy(() => import("pages/App_Catalogo/Tractor")));
const PageTransportista = Loadable(lazy(() => import("pages/App_Catalogo/Transportista")));
const PageRemolque = Loadable(
  lazy(() => import("pages/App_Catalogo/Remolque"))
);
const PageRemitente = Loadable(
  lazy(() => import("pages/App_Catalogo/Remitente"))
);
const PageConsignatario = Loadable(
  lazy(() => import("pages/App_Catalogo/Consignatario"))
);
const PageBroker = Loadable(lazy(() => import("pages/App_Catalogo/Broker")));
const PageManifiestoVacio = Loadable(
  lazy(() => import("pages/App_Aplicacion/_Operacion/ManifiestoVacio"))
);
const PageManifiestoCargado = Loadable(
  lazy(() => import("pages/App_Aplicacion/_Operacion/ManifiestoCargados"))
);
const PageManifiestoConfirmacion = Loadable(
  lazy(() => import("pages/App_Aplicacion/_Operacion/Confirmacion"))
);
const PageManifiestoGenerados = Loadable(
  lazy(() => import("pages/App_Aplicacion/_Operacion/ManifiestosGenerados"))
);
const ReporteUsuarios = Loadable(
  lazy(() => import("pages/App_Aplicacion/_Operacion/ReporteManifiestosUsuarios"))
);
const ReporteTramitesAduana = Loadable(
  lazy(() => import("pages/App_Aplicacion/_Operacion/ReporteManifiestosTtoADU"))
);
const PageManifiestoGuardados = Loadable(
  lazy(() => import("pages/App_Aplicacion/_Operacion/ManifiestosGuardados"))
); //
const PageUsuarios = Loadable(
  lazy(() => import("pages/App_Catalogo/Usuarios"))
); //
// ==============================|| MAIN ROUTES ||============================== //

const MainRoutes = {
  path: "/",
  children: [
    {
      path: "/",
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: "Inicio",
          element: <SamplePage />
        },
        {
          path: "dashboard",
          element: <Dashboard />
        },
        {
          path: "Chofer",
          element: <PageChofer />
        },
        {
          path: "Tractor",
          element: <PageTractor />
        },
        {
          path: "Remolque",
          element: <PageRemolque />
        },
        {
          path: "Remitente",
          element: <PageRemitente />
        },
        {
          path: "Consignatario",
          element: <PageConsignatario />
        },
        {
          path: "Broker",
          element: <PageBroker />
        },
        {
          path: "ManifiestoVacio",
          element: <PageManifiestoVacio />
        },
        {
          path: "AdmendedVacio",
          element: <PageManifiestoVacio />
        },
        {
          path: "DuplicateVacio",
          element: <PageManifiestoVacio />
        },
        {
          path: "Manifiesto",
          element: <PageManifiestoCargado />
        },
        {
          path: "AdmendedManifiesto",
          element: <PageManifiestoCargado />
        },
        {
          path: "DuplicateManifiesto",
          element: <PageManifiestoCargado />
        },
        {
          path: "Confirmacion",
          element: <PageManifiestoConfirmacion />
        },
        {
          path: "ManifiestoGenerados",
          element: <PageManifiestoGenerados />
        },
        {
          path: "ReporteUsuarios",
          element: <ReporteUsuarios />
        },
        {
          path: "TramitesAduana",
          element: <ReporteTramitesAduana />
        },
        {
          path: "ManifiestoGuardados",
          element: <PageManifiestoGuardados />
        },
        {
          path: "Documentacion",
          element: <PageDocumentacion />,
          title: "Documentacion"
        },
        {
          path: "Atencion",
          element: <PageInformacionContacto />,
          title: "Soporte"
        },
        {
          path: "AvisoGeneral",
          element: <AvisoGeneral />,
          title: "Aviso General"
        },
        {
          path: "AvisoAduana",
          element: <AvisoAduana />,
          title: "Aviso Aduana"
        },
        {
          path: "Usuarios",
          element: <PageUsuarios />,
          title: "Usuarios"
        },
        {
          path: "Transportista",
          element: <PageTransportista />,
          title: "ABC Transportista"
        },

      ]
    },
    {
      path: "/maintenance",
      element: <CommonLayout />,
      children: [
        {
          path: "404",
          element: <MaintenanceError />
        },
        {
          path: "500",
          element: <MaintenanceError500 />
        },
        {
          path: "under-construction",
          element: <MaintenanceUnderConstruction />
        },
        {
          path: "coming-soon",
          element: <MaintenanceComingSoon />
        }
      ]
    }
  ]
};

export default MainRoutes;
